<gwo-header [name]="name" />

<div class="content">
    <ng-content />
</div>
